const fetchComment = state => state.comments;
const fetchCommentsNextPage = state => state.next;
const fetchCommentsPreviosePage = state => state.previose;

export default {
  fetchComment,
  fetchCommentsNextPage,
  fetchCommentsPreviosePage,
};
